import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';

import { LoginService } from '../login/login.service';
import { of, switchMap } from 'rxjs';

export const noAuthGuard: CanActivateFn | CanActivateChildFn = () => {
  const router = inject(Router);
  const loginService = inject(LoginService);

  return loginService
    .isLoggedIn()
    .pipe(
      switchMap((authenticated) => {
        if (authenticated) {
          return of(router.parseUrl(''));
        }
        // If the user is authenticated, allow access
        return of(true);
      })
    );

};
